var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"badgeContainer"}},[_c('div',{staticClass:"badgeActual",on:{"click":function($event){$event.preventDefault();return _vm.englishVersion()}}},[_c('nav',[_vm._v("EN")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }